export enum AgentResidualsImportStatus {
  processing = 'Processing',
  imported = 'Imported',
  importedWithWarnings = 'Imported with warnings',
  error = 'Error',
}

export type RawAdjustmentData = {
  agentName: string;
  agentCode: string;
  group: string;
  description: string;
  amount: string;
  revShare: string;
};

export type AgentResidualsImport = {
  fileUrl: string;
  importedRawAdjustmentData: RawAdjustmentData[];
  yearMonth: string;
  status: AgentResidualsImportStatus;
  createdAt: Date;
  createdBy: string;
  importedIds: string[];
  totals: {
    items: number;
    net: number;
  };
  warnings: string[];
};
